import { deliveryMethods } from '@prolaera/library';

export default function() {
  return input => {
    let delMethods = deliveryMethods.reduce((obj, { key, name }) => {
      obj[key] = name;
      return obj;
    }, {});

    if (input === undefined) {
      return 'None';
    }
    return delMethods[input] || 'None';
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/DeliveryMethod.js